import i18n from 'i18next';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import { capitalizeFirstLetter } from '../pages/attendee/detail/components/utils';

export default class ModerationAttendee extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true },
            cache: false,
            allow_cache: false
        };
    }

    static listUrl({ organizationId, flowId }) {
        if (!organizationId) {
            throw new Error('[Moderation Attendees] OrganizationId is mandatory');
        }
        if (!flowId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/attendees`;
        }
        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/attendees`;
    }

    get attendeeResolvedName() {
        if (this.object.attendee_last_name) {
            return `${this.object.attendee_last_name.toUpperCase()} ${capitalizeFirstLetter(this.object.attendee_first_name)}`;
        }
        return i18n.t('ticket.manager.nonNominative').toUpperCase();
    }

    static triggerTransition(data, { organizationId, attendeeId, flowId }) {
        return fetcher.post(`/ticket/organizations/${organizationId}/moderation_flows/${flowId}/attendees/${attendeeId}/trigger_transition`, { data: data });
    }

    static getNextAttendee({ organizationId, flowId, query, skip = false }) {
        if (!organizationId) {
            throw new Error('[ModerationAttendee] OrganizationId is mandatory');
        }
        const queryString = 'skip_current=1';
        let queryParams = query;

        if (skip) {
            queryParams = query ? query?.concat('&', queryString) : queryString;
        }

        return fetcher
            .get(`${this.listUrl({ organizationId, flowId })}/next`, {
                cache: false,
                allow_cache: false,
                query: queryParams?.replace('?', '')
            })
            .then(({ response: { id } }) => {
                if (!flowId) {
                    return { id, url: `/ticket/O${organizationId}/moderation/moderation_attendees/${id}${query}` };
                }
                return { id, url: `/ticket/O${organizationId}/moderation/moderation_flows/${flowId}/moderation_attendees/${id}${query}` };
            });
    }

    static unlock({ organizationId, flowId, lockId }) {
        if (!organizationId || !lockId) {
            throw new Error('[ModerationAttendee] OrganizationId and lockId are mandatory');
        }
        if (!flowId) {
            return fetcher.delete(`/ticket/organizations/${organizationId}/moderation_flows/locks/${lockId}`);
        }
        return fetcher.delete(`/ticket/organizations/${organizationId}/moderation_flows/${flowId}/locks/${lockId}`);
    }
}
